const deploymentsPerDay = [
    {
        datetime: "2023-11-28T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 0,
                baseline: 2,
            },
            {
                name: "backend-server",
                value: 0,
                baseline: 2,
            },
            {
                name: "static-x",
                value: 1,
                baseline: 2,
            },
        ],
    },
    {
        datetime: "2023-11-29T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 1,
                baseline: 2,
            },
            {
                name: "backend-server",
                value: 1,
                baseline: 2,
            },
            {
                name: "static-x",
                value: 1,
                baseline: 2,
            },
        ],
    },
    {
        datetime: "2023-11-30T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 4,
                baseline: 2,
            },
            {
                name: "backend-server",
                value: 0,
                baseline: 1,
            },
            {
                name: "static-x",
                value: 2,
                baseline: 1,
            },
        ],
    },
    {
        datetime: "2023-12-01T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 0,
                baseline: 0,
            },
            {
                name: "backend-server",
                value: 1,
                baseline: 1,
            },
            {
                name: "static-x",
                value: 1,
                baseline: 3,
            },
        ],
    },
    {
        datetime: "2023-11-02T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 3,
                baseline: 2,
            },
            {
                name: "backend-server",
                value: 0,
                baseline: 0,
            },
            {
                name: "static-x",
                value: 3,
                baseline: 1,
            },
        ],
    },
    {
        datetime: "2023-11-03T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 1,
                baseline: 2,
            },
            {
                name: "backend-server",
                value: 1,
                baseline: 0,
            },
            {
                name: "static-x",
                value: 0,
                baseline: 0,
            },
        ],
    },
    {
        datetime: "2023-11-04T22:00:00.000Z",
        repos: [
            {
                name: "frontend-B2C",
                value: 4,
                baseline: 1,
            },
            {
                name: "backend-server",
                value: 1,
                baseline: 0,
            },
            {
                name: "static-x",
                value: 1,
                baseline: 1,
            },
        ],
    },
];

const deploymentStats = {
    totalDeployments: 12,
    successRate: {
        overall: 0.98,
        production: 0.79,
    },
    commitsPerDeployment: 9,
    mrsPerDeployment: 2,
    averageDuration: {
        execution: 1223,
        overall: 1233,
    },
    // avgSuccessRate: {
    //     overall: 0.9,
    //     production: 0.82,
    // },
    // avgCommitsPerDeployment: 12,
    // avgMrsPerDeployment: 2,
    // avgAverageDuration: {
    //     execution: 123,
    //     overall: 1223,
    // },
    baseline: {
        totalDeployments: 10.2,
        successRate: {
            overall: 0.9,
            production: 0.82,
        },
        commitsPerDeployment: 12,
        mrsPerDeployment: 2,
        averageDuration: {
            execution: 123,
            overall: 1223,
        },
    },
};

const deploymentsCount = {
    production: 21,
    overall: 43,
    baseline: {
        production: 14,
        overall: 43,
    },
};

const deploymentsInfo = [
    {
        datetime: "2023-11-28T21:11:32.000Z",
        id: 1,
    },
    {
        datetime: "2023-11-28T01:25:05.000Z",
        id: 2,
    },
    {
        datetime: "2023-11-28T15:34:01.000Z",
        id: 3,
    },
    {
        datetime: "2023-11-25T15:05:06.000Z",
        id: 4,
    },
];

const deploymentFrequencyRollbacks = [
    {
        datetime: "2023-11-28T22:00:00.000Z",
        rollbacks: 1,
        deployments: 3,
    },
    {
        datetime: "2023-11-29T22:00:00.000Z",
        rollbacks: 0,
        deployments: 2,
    },
    {
        datetime: "2023-11-30T22:00:00.000Z",
        rollbacks: 0,
        deployments: 1,
    },
    {
        datetime: "2023-12-01T22:00:00.000Z",
        rollbacks: 0,
        deployments: 5,
    },
    {
        datetime: "2023-12-02T22:00:00.000Z",
        rollbacks: 0,
        deployments: 1,
    },
    {
        datetime: "2023-12-03T22:00:00.000Z",
        rollbacks: 2,
        deployments: 4,
    },
    {
        datetime: "2023-12-04T22:00:00.000Z",
        rollbacks: 0,
        deployments: 0,
    },
];

const getDeployments = () => {
    return {
        deploymentsPerDay,
        deploymentStats,
        deploymentsCount,
        deploymentsInfo,
        deploymentFrequencyRollbacks,
    };
};

export default getDeployments;
